import React, { useState } from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span,
  Copy
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useModal, useToggle } from 'hooks'
import { ViewContractModal } from 'pages/NGT/CRE/components/ViewContractModal/ViewContractModal'
import { ISearchDjurItems } from 'services/NGT/DjurServices'
import { COLORS, FORMAT } from 'utils'

import { useDjurService } from '../../../../context'
import { IDetailsDjur } from '../../../../DJURService'

interface ITableServicesDjur {
  tableData: ISearchDjurItems[]
  handleDjurDetails: (_type: IDetailsDjur) => void
  rowsPerPage: number
  page: number
  pageCount: number
  handleChangeRowsPerPage: (
    _event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleChangePage: (_newPage: number) => void
}

const TableServicesDjur: React.FC<ITableServicesDjur> = ({
  tableData,
  handleDjurDetails,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  pageCount,
  rowsPerPage
}) => {
  const { showModal } = useModal()
  const { dispatch } = useDjurService()

  const [openViewContractModal, handleToggleViewContractModal] = useToggle()
  const [contractID, setContractID] = useState<number>(0)

  const onClickAction = (djurInfo: any) => {
    showModal({
      handleCancel: () => {
        handleDjurDetails({
          ...djurInfo,
          type: 'consult'
        })
        dispatch({ payload: djurInfo, type: 'handleChangeDjurTarget' })
        dispatch({
          payload: { tabType: 'consult' },
          type: 'handleChangeTabType'
        })
      },
      handleConfirm: () => {
        handleDjurDetails({
          ...djurInfo,
          type: 'reanalize'
        })
        dispatch({ payload: djurInfo, type: 'handleChangeDjurTarget' })
        dispatch({
          payload: { tabType: 'reanalize' },
          type: 'handleChangeTabType'
        })
      },
      hideThirdButton: false,
      titleModal: 'Reanálise ou Consulta? ',
      txtButtonCancel: 'Consulta',
      txtButtonConfirm: 'Reanálise',
      txtButtonThird: 'Voltar',
      type: 'alert',
      typeButtonCancel: 'outlined'
    })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left">Atendimento DJUR</TableCellStyled>
              <TableCellStyled align="left">Cervello</TableCellStyled>
              <TableCellStyled align="left">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Fornecedor</TableCellStyled>
              <TableCellStyled align="left">CPF/Passaporte</TableCellStyled>
              <TableCellStyled align="left">Processo</TableCellStyled>
              <TableCellStyled align="left">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData?.map((row) => (
                <TableRowStyled key={row.idAtendimentoDjur}>
                  <TableCellStyled align="left">
                    <Copy
                      valueToCopy={row.codigoContrato}
                      title="Copiar código de contrato"
                    />
                  </TableCellStyled>
                  <TableCellStyled
                    align="left"
                    onClick={() => {
                      setContractID(row.idContrato)
                      handleToggleViewContractModal()
                    }}
                  >
                    <Span text={row.codigoContrato} color={COLORS.blueFonts} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.cdAtendimentoDjur}
                  </TableCellStyled>
                  <TableCellStyled align="left">{row.cervello}</TableCellStyled>
                  <TableCellStyled align="left">
                    {isNaN(parseInt(row.cnpjFornecedor))
                      ? row.cnpjFornecedor
                      : FORMAT.formatCdDocto(row.cnpjFornecedor)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nomeFornecedor}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatCdDocto(row.cpfReclamante)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.processoReclamante}
                  </TableCellStyled>
                  <TableCellStyled
                    align="center"
                    onClick={() => onClickAction(row)}
                  >
                    <MagnifyingGlassIcon style={{ justifyContent: 'center' }} />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="online"
      />
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={handleToggleViewContractModal}
        contractID={contractID}
      />
    </>
  )
}

export default TableServicesDjur
